var tooltipIsDocMode = function tooltipIsDocMode() {
  return !!document.getElementById('story--components-tooltip--basic-usage--primary');
};

export { tooltipIsDocMode };
